import React, { Component } from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import CDCModalInput from "./cdc-modal-input";

class CDCAddressForm extends Component {
  static propTypes = {
    address: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    dataType: PropTypes.string,
    panelStatus: PropTypes.string,
    handleChange: PropTypes.func,
  };

  static defaultProps = {
    address: {},
    dataType: "",
    panelStatus: "",
    handleChange: _.noop,
  };

  state = {
    type: this.props.address.type || "",
    address_1: this.props.address.address_1 || "",
    address_2: this.props.address.address_2 || "",
    address_3: this.props.address.address_3 || "",
    city: this.props.address.city || "",
    state: this.props.address.state || "",
    zip_code: this.props.address.zip_code || "",
    country: this.props.address.country || "USA",
  };

  handleChange = (value, id) => {
    this.setState({ [id]: value }, () => {
      this.props.handleChange(_.pick(this.state, _.identity));
    });
  };

  render() {
    const { address_1, address_2, address_3, city, state, zip_code, country } = this.state;
    return (
      <div className="cdc-controller--address-form">
        <CDCModalInput
          dataType={this.props.dataType}
          panelStatus={this.props.panelStatus}
          label="Address 1*"
          value={address_1}
          handleChange={event => this.handleChange(event, "address_1")}
          isRequired
        />
        <CDCModalInput
          dataType={this.props.dataType}
          panelStatus={this.props.panelStatus}
          label="Address 2 (optional)"
          value={address_2}
          handleChange={event => this.handleChange(event, "address_2")}
        />
        <CDCModalInput
          dataType={this.props.dataType}
          panelStatus={this.props.panelStatus}
          label="Address 3 (optional)"
          value={address_3}
          handleChange={event => this.handleChange(event, "address_3")}
        />
        <div className="cdc-controller--address-form-row">
          <CDCModalInput
            dataType={this.props.dataType}
            panelStatus={this.props.panelStatus}
            label="City*"
            value={city}
            handleChange={event => this.handleChange(event, "city")}
            isRequired
          />
          <CDCModalInput
            dataType={this.props.dataType}
            panelStatus={this.props.panelStatus}
            label="State*"
            value={state}
            handleChange={event => this.handleChange(event, "state")}
            isRequired
          />
        </div>
        <div className="cdc-controller--address-form-row">
          <CDCModalInput
            dataType={this.props.dataType}
            panelStatus={this.props.panelStatus}
            label="Zip Code*"
            value={zip_code}
            handleChange={event => this.handleChange(event, "zip_code")}
            isRequired
          />
          <CDCModalInput
            dataType={this.props.dataType}
            panelStatus={this.props.panelStatus}
            label="Country*"
            value={country}
            handleChange={event => this.handleChange(event, "country")}
            isRequired
          />
        </div>
      </div>
    );
  }
}

export default CDCAddressForm;
